































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardsConfig } from '@/type/CardsConfig';

// components
import CardBlock from './CardBlock.vue';

// vuex
import FreeCellStore from '@/FreeCellStore';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    CardBlock
  }
})
export default class FreeCellTable extends Vue {
  storeModule = getModule(FreeCellStore, this.$store);
  isMounted: boolean = false;

  get mousedowbPos(): { x: number; y: number } {
    return this.$store.state.FreeCellStore.mousedowbPos;
  }
  set mousedowbPos(val: { x: number; y: number }) {
    this.storeModule.SET_MOUST_POS(val);
  }

  get isDrag(): boolean {
    return this.$store.state.FreeCellStore.isDrag;
  }
  set isDrag(val: boolean) {
    this.storeModule.SET_MOUST_TYPE(val);
  }

  get cards(): [] {
    return this.$store.state.FreeCellStore.cards;
  }

  get cacheCards(): CardsConfig[] {
    return this.filterCardHandler('cache');
  }

  get completeCards(): CardsConfig[] {
    return this.filterCardHandler('complete');
  }

  get playregionCards(): CardsConfig[] {
    return this.filterCardHandler('playregion');
  }

  mounted() {
    this.storeModule.GET_CARDS();
    this.isMounted = true;
  }

  filterCardHandler(type: string) {
    return this.cards.filter((obj: CardsConfig) => obj.type === type);
  }

  mousedownHandler(e: MouseEvent) {
    let x: number = e.pageX,
      y: number = e.pageY;
    this.isDrag = true;
    this.mousedowbPos = { x, y };
  }

  mouseupHandler(e: MouseEvent) {
    this.isDrag = false;
    this.mousedowbPos = { x: 0, y: 0 };
  }
}
